import { usePosEnv } from "../lib/runtime";

// Unmissable "this is not production" flag, mounted once at the app root
// (App.tsx) so every surface — kiosk, admin, server, KDS, CFD, pay screens —
// gets it with zero per-page wiring. Renders null unless /api/config resolves
// a non-prod env (worker POS_ENV — see CLAUDE.md "Environments"). Two variants:
//   staging → amber, the shared test environment the venue also touches
//   dev     → indigo, a laptop-only environment (docs/DEV-ENV.md)
// Different colors on purpose: with dev and staging open in adjacent tabs,
// two identical bars would be worse than no bar at all.
//
// Normal document flow, NOT `fixed` — it was fixed+overlay originally, but
// that covers whatever a page renders at its own top (AdminShell's header,
// kiosk attract art, etc.) since nothing reserves space for it. Sitting in
// flow as the first element under <App> pushes every surface down by its own
// height instead, with the same zero-per-page-wiring property.
//
// Ops chrome, not a new visual language (CLAUDE.md rule 8) — one shared bar
// for both kiosk and POS surfaces, no per-surface variants.
export default function EnvBanner() {
  const env = usePosEnv();
  if (env !== "staging" && env !== "dev") return null;
  const dev = env === "dev";
  return (
    <div
      role="alert"
      className={`w-full font-extrabold text-sm sm:text-lg md:text-xl tracking-wide text-center px-4 py-2 sm:py-3 shadow-lg border-b-4 border-black/70 ${
        dev ? "bg-indigo-500 text-white" : "bg-amber-400 text-black"
      }`}
    >
      {dev
        ? "⚙ AMBIENTE DE DESARROLLO — LOCAL — NO ES PRODUCCIÓN ⚙"
        : "⚠ AMBIENTE DE PRUEBAS — TEST ENVIRONMENT — NO ES PRODUCCIÓN ⚠"}
    </div>
  );
}
